// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gttc","select":"styles_select__3TwgO"};